<template>
  <div
    class="accordion"
    @dragover="handleDragOver($event)"
    @drop="drop"
    @dragenter="handleDragOver($event)"
  >
    <div class="header" @click="collapse">
      <i class="material-icons" v-if="!collapseBool">expand_more</i>
      <i class="material-icons" v-if="collapseBool">expand_less</i>
      <span class="title">Footer Column {{ idx + 1 }}</span>
    </div>
    <div class="container" v-if="collapseBool">
      <span>Title:</span>
      <input type="text" v-model="localValue.title" maxlength="255" />
      <div id="quill-wrap">
        <quillEditor
          ref="myQuillEditor"
          class="quill"
          :options="defaultOptions"
          v-model="localValue.text"
          v-if="currentType == 'text'"
        />
        <AceEditor
          @init="editorInit"
          v-if="currentType == 'html'"
          v-model="localValue.text"
          lang="html"
          theme="monokai"
          width="100%"
          height="235px"
          :options="{
            enableBasicAutocompletion: true,
            enableLiveAutocompletion: true,
            fontSize: 14,
            highlightActiveLine: true,
            enableSnippets: true,
            showLineNumbers: true,
            tabSize: 2,
            showPrintMargin: false,
            showGutter: true,
          }"
          :commands="[
            {
              name: 'save',
              bindKey: { win: 'Ctrl-s', mac: 'Command-s' },
              exec: saveData,
              readOnly: true,
            },
          ]"
        />
      </div>
      <div class="btn-container">
        <a-button type="primary" class="delete" @click="deleteData">
          Delete
        </a-button>
        <a-button type="primary" class="save" @click="saveData">
          Save
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import AceEditor from 'vuejs-ace-editor'
export default {
  components: {
    quillEditor,
    AceEditor,
  },
  props: {
    idx: {
      type: Number,
    },
    valueObj: {
      type: Object,
    },
    draggingObject: {
      type: Object,
    },
    selectedColumnSet: {
      type: Number,
    },
  },
  data() {
    return {
      initialColumnSet: null,
      collapseBool: false,
      localValue: {},
      defaultOptions: {
        theme: 'snow',
        boundary: document.body,
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline'],
            // ["blockquote", "code-block"],
            // [{ header: 1 }, { header: 2 }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            // [{ script: "sub" }, { script: "super" }],
            // [{ indent: "-1" }, { indent: "+1" }],
            // [{ direction: "rtl" }],
            // [{ size: ["small", false, "large", "huge"] }],
            // [{ header: [1, 2, 3, 4, 5, 6, false] }],
            // [{ color: [] }, { background: [] }],
            // [{ font: [] }],
            // [{ align: [] }],
            // ["clean"],
            ['link'],
          ],
        },
        placeholder: 'Insert text here ...',
        readOnly: false,
      },
      currentType: 'text',
    }
  },
  watch: {
    draggingObject: {
      deep: true,
      handler(val) {
        console.log(val)
        if (val.idx == this.idx) {
          console.log('menjaj ' + this.idx + ' u ' + val.type)
          this.currentType = val.type
        }
      },
    },
    collapseBool: {
      handler() {
        this.setLocalValue()
      },
    },
    valueObj: {
      handler() {
        this.setLocalValue()
      },
    },
  },
  mounted() {
    this.listenForClearAccordionFields()
    this.setLocalValue()
    this.initialColumnSet = localStorage.getItem('initialColumnSet')
  },
  methods: {
    editorInit: function () {
      require('brace/ext/language_tools') //language extension prerequsite...
      require('brace/mode/html')
      require('brace/mode/javascript') //language
      require('brace/mode/less')
      require('brace/theme/monokai')
      require('brace/snippets/javascript') //snippet
    },
    handleDragOver(e) {
      e.preventDefault()
    },
    drop() {
      this.$emit('droppedAt', this.idx)
    },
    setLocalValue() {
      this.localValue = JSON.parse(JSON.stringify(this.valueObj))
    },
    collapse() {
      this.collapseBool = !this.collapseBool
    },
    saveData() {
      this.$emit('save', this.localValue)
    },
    deleteData() {
      this.$emit('save', {})
    },
    listenForClearAccordionFields(){
      this.EventBus.$on('clearAccordionFields',data=>{
        if(data == this.initialColumnSet) {
          this.setLocalValue()
        }
        else{
          this.localValue.text = ''
        }
      })
    },

  },
}
</script>

<style scoped lang="scss">
.ace_editor {
  margin: 20px 0;
}
.accordion {
  cursor: pointer;
  margin: 50px 40px 0 0;
  border: 1px solid #dfe1e6;
  .header {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 302px;
    min-height: 46px;
    background: #f4f5f7;
    padding: 20px;
    .material-icons {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    span {
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 22px;
      color: #001529;
      margin: 0 20px;
    }
  }
  .container {
    min-height: 400px;
    width: 300px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    padding: 0 16px;
    span {
      align-self: flex-start;
    }
    input {
      border-radius: 0;
    }
    .quill {
      width: 100%;
      margin: 16px 0;
    }
    .btn-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      button {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 22px;
        color: #ffffff;
        border: none;
        &.delete {
          background: #d23214;
        }
        &.save {
          background: #4bc076;
        }
      }
    }
  }
}
</style>

<style lang="scss">
#quill-wrap {
  width: 100%;
  .quill {
    .ql-editor {
      height: 200px;
    }
  }
}
.ql-tooltip, .ql-editing {
  left: 0 !important;
}
</style>
